import { render, staticRenderFns } from "./PaymentDisputes.vue?vue&type=template&id=20b236c0&"
import script from "./PaymentDisputes.vue?vue&type=script&lang=js&"
export * from "./PaymentDisputes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports